import { useHistory } from 'react-router-dom';
import { useStoreActions } from "../contexts";
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { handleRequest } from "../infra/utils";
import { routes } from "../constants";
import { useCreateRelationshipFromDraft } from "./useCreateRelationshipFromDraft";
import { useSetWorksAtOptimisticUpdate } from "./useSetWorksAtOptimisticUpdate";
import { jsx as _jsx } from "react/jsx-runtime";
export const useScheduledProposal = _ref => {
  let {
    draftId,
    refresh,
    onCloseCancelSchedulingModal
  } = _ref;
  const {
    api
  } = useStoreActions();
  const history = useHistory();
  const {
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const createRelationshipFromDraft = useCreateRelationshipFromDraft();
  const updateWorksAt = useSetWorksAtOptimisticUpdate();
  const sendNow = async () => {
    overlayContext.stopLoader('send-now');
    logBI(11353);
    const result = await handleRequest(createRelationshipFromDraft(draftId));
    if (result.success) {
      updateWorksAt(false, false);
      overlayContext.stopLoader('send-now');
      overlayContext.showSuccessToast('Proposal sent successfully', 'send-now-success-toast');
      refresh();
    } else {
      const {
        text
      } = result.error.createRelationshipErrorText();
      overlayContext.showErrorToast(text, 'create-relationship-error');
      overlayContext.stopLoader('send-now');
      return;
    }
  };
  const cancelScheduledProposal = async () => {
    overlayContext.startLoader('cancel-scheduled-proposal');
    logBI(11354);
    const result = await handleRequest(api.draft.cancelScheduledProposal({
      draftId
    }));
    if (result.success) {
      overlayContext.showSuccessToast('Scheduling canceled successfully', 'cancel-scheduled-proposal-success-toast');
      overlayContext.stopLoader('cancel-scheduled-proposal');
      refresh();
    } else {
      overlayContext.showErrorToast(result.error, 'cancel-scheduled-proposal-error');
      overlayContext.stopLoader('cancel-scheduled-proposal');
      return;
    }
  };
  const handleCancelSchedulingAndEdit = dismissModal => {
    cancelScheduledProposal();
    dismissModal(true);
    if (history.location.pathname !== routes.draft(draftId)) {
      history.push(routes.draft(draftId));
    }
  };
  const handleCloseCancelSchedulingModal = dismissModal => {
    onCloseCancelSchedulingModal === null || onCloseCancelSchedulingModal === void 0 || onCloseCancelSchedulingModal();
    dismissModal(false);
  };
  const showCancelSchedulingModal = () => {
    overlayContext.showModal({
      closeOnClickOutside: false,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          title: "Cancel scheduling to edit",
          skin: "danger",
          "data-testid": "cancel-scheduling-modal",
          primaryButtonLabel: "Cancel scheduling and edit",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => handleCancelSchedulingAndEdit(dismissModal),
          onSecondaryButtonClick: () => handleCloseCancelSchedulingModal(dismissModal),
          onCloseButtonClick: () => handleCloseCancelSchedulingModal(dismissModal),
          content: /*#__PURE__*/_jsx(Typography, {
            children: "In order to edit a scheduled proposal, its scheduling must be canceled."
          })
        });
      }
    });
  };
  return {
    sendNow,
    cancelScheduledProposal,
    handleCancelSchedulingAndEdit,
    showSwitchToEditModal: showCancelSchedulingModal
  };
};